// #584 Vorauswahl: Bei mehreren Objekten wählt der Eigentümer nach dem Login zuerst das Objekt,
// erst danach erscheinen Übersicht und die Bereiche. Zurück über „Alle Objekte“ im Objekt-Umschalter.
import { Buildings, BuildingApartment, CaretRight } from '@phosphor-icons/react';
import { IconChip, SeitenTitel, StatusChip } from '../../components/portal/bausteine';
import { artIstWeg, ueberZeile, umschalterZeile, type EigDaten, type ObjektSicht } from '../../lib/portal/eigentuemer';

export interface AuswahlHinweise { rechnungen: number; einsaetze: number }

export default function ObjektAuswahl({ objekte, daten, oben, hinweise, onWahl }: {
  objekte: ObjektSicht[];
  daten: EigDaten;
  oben: string;
  hinweise: (objektId: string) => AuswahlHinweise;
  onWahl: (id: string) => void;
}) {
  return (
    <div className="p-rein" style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <SeitenTitel oben={oben} titel="Ihre Objekte" rechts={`${objekte.length} Objekte`} />
      <span style={{ fontSize: 14, fontWeight: 600, color: 'var(--p-w55)', padding: '0 4px' }}>
        Bitte wählen Sie das Objekt, das Sie ansehen möchten. Wechseln können Sie jederzeit oben im Titel.
      </span>
      <div className="ep-auswahl">
        {objekte.map((o) => {
          const weg = artIstWeg(o.art);
          const ueber = ueberZeile(daten, o.objekt);
          const h = hinweise(o.objekt.id);
          const ort = [o.objekt.plz, o.objekt.stadt].filter(Boolean).join(' ');
          return (
            <button key={o.objekt.id} type="button" className="p-glas p-hebt ep-auswahl-kachel" onClick={() => onWahl(o.objekt.id)}
              aria-label={`${o.name} öffnen`}>
              <IconChip farbe={weg ? 'gemein' : 'wohnung'} icon={weg ? BuildingApartment : Buildings} groesse={44} />
              <span style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 2, textAlign: 'left' }}>
                <span className="p-kuerzen" style={{ fontSize: 17, fontWeight: 800 }}>{o.name}</span>
                {ort && <span className="p-kuerzen" style={{ fontSize: 13, fontWeight: 600, color: 'var(--p-w55)' }}>{ort}</span>}
                <span className="p-kuerzen" style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--p-w50)' }}>{umschalterZeile(o)}</span>
                {ueber && <span className="p-kuerzen" style={{ fontSize: 12.5, fontWeight: 700, color: 'var(--p-gold-text)' }}>{ueber}</span>}
                {(h.rechnungen > 0 || h.einsaetze > 0) && (
                  <span style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 6 }}>
                    {h.rechnungen > 0 && <StatusChip ton="warn">{h.rechnungen === 1 ? '1 Rechnung wartet' : `${h.rechnungen} Rechnungen warten`}</StatusChip>}
                    {h.einsaetze > 0 && <StatusChip ton="info">{h.einsaetze === 1 ? '1 offener Vorgang' : `${h.einsaetze} offene Vorgänge`}</StatusChip>}
                  </span>
                )}
              </span>
              <CaretRight size={18} weight="bold" style={{ color: 'var(--p-w45)', flexShrink: 0 }} />
            </button>
          );
        })}
      </div>
    </div>
  );
}
